import { handleActions, combineActions } from "redux-actions";
import { AppState } from "../../../models";
import { AllLanguageListAcionTypes } from "../../actions";

const allLanguageListState: AppState.AllLanguageListState = {
  loading: false,
  data: [],
};

export const AllLanguageListReducer = handleActions(
  {
    /* tên trong action phải giống khi sử dụng nhưng khác là dùng camelCase */
    [combineActions(
        AllLanguageListAcionTypes.loadAllLanguageStart,
        AllLanguageListAcionTypes.loadAllLanguageSuccess
    ).toString()]: (state: AppState.AllLanguageListState, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  allLanguageListState
);
